import { useEffect, useState } from 'react';
import AppHeader from '../../components/AppHeader';
import { chaptersApi } from '../../api';

export default function ChaptersAdmin() {
  const [chapters, setChapters] = useState([]);
  const [form, setForm] = useState({ name: '', region: '', code: '' });
  const [error, setError] = useState('');

  const load = () => chaptersApi.list().then((r) => setChapters(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await chaptersApi.create(form);
      setForm({ name: '', region: '', code: '' });
      load();
    } catch (err) {
      setError(err.response?.data?.error || 'Vytvoření selhalo.');
    }
  };

  const regenerate = async (id) => { if (confirm('Přegenerovat připojovací kód? Starý přestane platit.')) { await chaptersApi.regenerateCode(id); load(); } };
  const remove = async (id) => { if (confirm('Smazat spolek? Smažou se i jeho členové a sklad.')) { await chaptersApi.delete(id); load(); } };

  return (
    <div>
      <AppHeader subtitle="Oblastní spolky" />
      <div className="container-wide" style={{ paddingTop: 24 }}>
        <div className="card mb-16">
          <h3 className="mb-16">Nový spolek</h3>
          <form onSubmit={create}>
            <div className="flex gap-8">
              <div className="form-group flex-1">
                <label>Název</label>
                <input className="form-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required />
              </div>
              <div className="form-group flex-1">
                <label>Region</label>
                <input className="form-input" value={form.region} onChange={(e) => setForm({ ...form, region: e.target.value })} />
              </div>
              <div className="form-group" style={{ width: 140 }}>
                <label>Kód/IČO</label>
                <input className="form-input" value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value })} />
              </div>
            </div>
            {error && <div className="alert alert-warning mb-16">{error}</div>}
            <button type="submit" className="btn btn-primary">Vytvořit spolek</button>
          </form>
        </div>

        <div className="table-wrapper">
          <table>
            <thead><tr><th>Spolek</th><th>Region</th><th>Připojovací kód</th><th>Členů</th><th>Položek</th><th></th></tr></thead>
            <tbody>
              {chapters.map((c) => (
                <tr key={c.id}>
                  <td>{c.name}</td>
                  <td>{c.region || ''}</td>
                  <td><code style={{ fontSize: '1rem', letterSpacing: '0.08em' }}>{c.join_code}</code></td>
                  <td>{c.member_count}</td>
                  <td>{c.inventory_count}</td>
                  <td style={{ whiteSpace: 'nowrap' }}>
                    <button className="btn btn-outline btn-sm" onClick={() => regenerate(c.id)}>Nový kód</button>{' '}
                    <button className="btn btn-danger btn-sm" onClick={() => remove(c.id)}>Smazat</button>
                  </td>
                </tr>
              ))}
              {chapters.length === 0 && <tr><td colSpan={6} className="text-muted text-center">Žádné spolky.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
